module.exports = __webpack_public_path__ + "static/media/Phone.e41e2959.svg";